export default __webpack_public_path__ + "static/media/trooper.c4afb545.png";